import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

const BTN = "border border-black px-3 py-1.5 text-xs uppercase tracking-widest transition-colors duration-100 disabled:opacity-50";
const day = (iso) => new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });

function Frame({ open, onClose, title, desc, testId, children, footer }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="rounded-none border-2 border-black sm:max-w-md" data-testid={testId}>
        <DialogHeader>
          <DialogTitle className="font-chivo text-xl font-black">{title}</DialogTitle>
          <DialogDescription>{desc}</DialogDescription>
        </DialogHeader>
        {children}
        <DialogFooter className="gap-2">{footer}</DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// Change the reason on a pause that's still on; affiliates can be emailed the new reason.
export function EditReasonDialog({ row, busy, onClose, onSave }) {
  const [note, setNote] = useState("");
  const [email, setEmail] = useState(false);
  useEffect(() => {
    setNote(row?.note || "");
    setEmail(false);
  }, [row]);
  return (
    <Frame open={!!row} onClose={onClose} title={row?.note ? "Edit reason" : "Add reason"} desc={row?.target_name} testId="edit-reason-dialog"
           footer={<>
             <button type="button" onClick={onClose} className={`${BTN} hover:bg-zinc-100`} data-testid="edit-reason-cancel">Cancel</button>
             <button type="button" disabled={busy} onClick={() => onSave(note.trim(), email && !!note.trim())}
                     className={`${BTN} bg-black text-white hover:bg-zinc-800`} data-testid="edit-reason-save">Save</button>
           </>}>
      <div>
        <label htmlFor="edit-reason" className="label-mono mb-1 block">Reason</label>
        <Textarea id="edit-reason" value={note} maxLength={300} rows={3} onChange={(e) => setNote(e.target.value)}
                  className="rounded-none border-black" data-testid="edit-reason-input" />
        <div className="mt-1 text-right text-[10px] text-zinc-500">{note.length}/300</div>
        {row?.kind === "vendor" && (
          <label className="mt-2 flex cursor-pointer items-start gap-2 text-xs">
            <input type="checkbox" checked={email} disabled={!note.trim()} onChange={(e) => setEmail(e.target.checked)}
                   className="mt-0.5" data-testid="edit-reason-email" />
            <span>Email the affiliate the new reason <span className="text-zinc-500">(otherwise only admins see it)</span></span>
          </label>
        )}
      </div>
    </Frame>
  );
}

// Confirm keeping a pause on for 30 more days with no reminder emails.
export function SnoozeConfirmDialog({ row, busy, onClose, onConfirm }) {
  const until = day(new Date(Date.now() + 30 * 86400000).toISOString());
  return (
    <Frame open={!!row} onClose={onClose} title="Keep paused 30 more days?" testId="snooze-dialog"
           desc={`${row?.target_name || ""} stays paused and you won't get reminder emails about it until ${until}.`}
           footer={<>
             <button type="button" onClick={onClose} className={`${BTN} hover:bg-zinc-100`} data-testid="snooze-cancel">Cancel</button>
             <button type="button" disabled={busy} onClick={onConfirm}
                     className={`${BTN} bg-black text-white hover:bg-zinc-800`} data-testid="snooze-confirm">Keep paused</button>
           </>} />
  );
}

export { day };
